var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: ["box", { "is-highlighted": _vm.highlight }, "score-panel"] },
    [
      _c("div", { staticClass: "score-header" }, [
        _vm.heading
          ? _c(
              "h3",
              {
                staticClass: "title is-6 is-marginless",
                class: { "column-tooltip": _vm.tooltip },
              },
              [
                _vm._v(" " + _vm._s(_vm.heading) + " "),
                _vm.tooltip
                  ? _c("tooltip", {
                      class: ["feature", { "is-highlighted": _vm.highlight }],
                      attrs: {
                        icon: "question-circle",
                        library: "fas",
                        position: "is-right",
                        tip: _vm.tooltip,
                        size: "is-medium",
                      },
                    })
                  : _vm._e(),
              ],
              1
            )
          : _vm._e(),
        _vm.subtitle
          ? _c("p", { staticClass: "is-size-6" }, [
              _vm._v(_vm._s(_vm.subtitle)),
            ])
          : _vm._e(),
      ]),
      _vm.scoreData
        ? _c("div", { staticClass: "score-data" }, [
            _vm.validScore
              ? _c("p", { staticClass: "is-size-3" }, [
                  _c("strong", { style: "color: " + _vm.colour + ";" }, [
                    _vm._v(_vm._s(_vm.score)),
                  ]),
                ])
              : _c("p", [
                  _c("span", { style: "color: " + _vm.colour + ";" }, [
                    _vm._v(_vm._s(_vm.score)),
                  ]),
                ]),
            !_vm.showChange
              ? _c(
                  "p",
                  { class: ["is-size-6", "score-growth", _vm.growthColour] },
                  [
                    _vm.direction
                      ? _c("dc-icon", {
                          attrs: {
                            icon: "arrow-" + _vm.direction,
                            library: "fas",
                            "no-margin": "",
                          },
                        })
                      : _vm._e(),
                    _c("span", {
                      domProps: { textContent: _vm._s(_vm.change + "%") },
                    }),
                    _vm.growthLabel
                      ? _c("span", {
                          domProps: { textContent: _vm._s(_vm.growthLabel) },
                        })
                      : _vm._e(),
                  ],
                  1
                )
              : _vm._e(),
          ])
        : _c(
            "div",
            { staticClass: "score-data" },
            [
              _vm.isFetching
                ? _c("dc-icon", {
                    attrs: { icon: "sync", "no-margin": "", spin: "" },
                  })
                : _vm._e(),
              _c("span", { domProps: { textContent: _vm._s(_vm.label) } }),
            ],
            1
          ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }